export default {
  title: 'Zgody',
  type: 'object',
  properties: {
    termIds: {
      type: 'array',
      items: {
        type: 'number'
      },
      validFunc: `{
          const required = $external.requiredTerms;
          const isValid = required && required.length ? !!$value && !!$value.length && $methods.includesAll($value, required) : true;
          return isValid;
        }`,
      validationMessages: {
        validFunc: 'Wszystkie wymagane zgody muszą zostać udzielone.'
      }
    }
  }
};
